export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ru": {
        "create_request": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создать заявку"])}
      },
      "en": {
        "create_request": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create request"])}
      }
    }
  })
}
